import React from 'react';
import Skeleton from '../Common/Skeleton';

/**
 * ProjectOverviewSkeleton — Overview tab loading placeholder.
 */
const ProjectOverviewSkeleton = () => (
  <div className="project-overview project-overview--skeleton" aria-busy="true" aria-label="Loading overview">
    <div className="project-overview__row project-overview__row--split">
      <div className="project-overview__skeleton-card project-overview__skeleton-card--tall">
        <Skeleton width="40%" height={18} />
        <Skeleton width="100%" height={72} className="project-overview__skeleton-gap" />
        <Skeleton width="100%" height={20} className="project-overview__skeleton-gap" />
        <Skeleton width="100%" height={20} />
        <Skeleton width="70%" height={20} />
      </div>
      <div className="project-overview__stack">
        <div className="project-overview__skeleton-card">
          <Skeleton width="50%" height={16} />
          <Skeleton width="60%" height={36} className="project-overview__skeleton-gap" />
        </div>
        <div className="project-overview__skeleton-card">
          <Skeleton width="45%" height={16} />
          <Skeleton width="40%" height={36} className="project-overview__skeleton-gap" />
        </div>
        <div className="project-overview__skeleton-card">
          <Skeleton width="55%" height={16} />
          <Skeleton width="35%" height={36} className="project-overview__skeleton-gap" />
        </div>
      </div>
    </div>

    <div className="project-overview__row project-overview__row--split">
      <div className="project-overview__skeleton-card project-overview__skeleton-card--tall">
        <Skeleton width="35%" height={18} />
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} width="100%" height={28} className="project-overview__skeleton-gap" />
        ))}
      </div>
      <div className="project-overview__skeleton-card project-overview__skeleton-card--tall">
        <Skeleton width="40%" height={18} />
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} width="100%" height={36} className="project-overview__skeleton-gap" />
        ))}
      </div>
    </div>
  </div>
);

export default ProjectOverviewSkeleton;
